import { render, staticRenderFns } from "./dynamic-component-config-manager.vue?vue&type=template&id=79023eb0&scoped=true"
import script from "./dynamic-component-config-manager.vue?vue&type=script&lang=ts"
export * from "./dynamic-component-config-manager.vue?vue&type=script&lang=ts"
import style0 from "./dynamic-component-config-manager.vue?vue&type=style&index=0&id=79023eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79023eb0",
  null
  
)

export default component.exports